import React, { useEffect, useState } from "react";
import { Avatar, Button, DetailCard, LogoLoader, showToast } from "../../../../../components";
// import { getNotes } from "../../../../../redux/slices/accountDetails/accountDetailsApi";
import dayjs from "dayjs";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { getNotes } from "../../../../../redux/slices/accountDetails/accountDetailsAPi";
import { convertFromUTC } from "../../../../../utils/dateUtils";
import { useDispatch, useSelector } from "react-redux";
import { updateApplicantNotesList } from "../../../../../redux/slices/internalDbES/internalDbESlice";
import { updateApplicantNotesListBDM } from "../../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { updateApplicantsNotesArray } from "../../../../../redux/slices/recruitmentSourcing/SourcingSlice";

const Notes = ({ applicantId, refreshKey, openNotesModal, source }) => {
  // let applicants = useSelector((state) => state.sourcing.applicants);
  // applicants = applicants?.data
  // const notesList = applicants?.find(applicant => applicant?.uiid == applicantId)?.notesList || []

  const dispatch = useDispatch();

  const notesList = useSelector(state => {
    // sourcing applicants
    const sourcingApplicants = state.sourcing.applicants?.data || [];
    const sourcingNotes =
      sourcingApplicants.find(a => a?.uiid === applicantId)?.notesList;
    if (sourcingNotes) return sourcingNotes;

    // internal DB / job boards
    const slice = state.internalDbES;
    const sourceMap = {
      1: Array.isArray(slice.totalApplicantsData)
        ? slice.totalApplicantsData
        : slice.totalApplicantsData?.data || [],
      2: slice.careerBuilder?.existingCandidates || [],
      3: slice.monster?.existingCandidates || [],
    };
    const list = sourceMap[source] || [];
    const internalNotes = list.find(c => c?.uiid === applicantId)?.notesList;

    if (internalNotes?.length > 0) return internalNotes;

    // return list.find(c => c?.uiid === applicantId)?.notesList || [];

    const bdm = state.bdmJobs || {};
    const bdmLists = [
      bdm.pipeline?.data,
      bdm.confirmedOrStart?.data,
      bdm.followupInterviews?.data,
      bdm.clientsubmissions?.data,
    ];
    for (const arr of bdmLists) {
      if (!Array.isArray(arr)) continue;
      const notes = arr.find(c => c?.candidateId?.uiid === applicantId)?.notesList;
      if (notes) return notes;
    }
    return [];
  });

  const [notes, setNotes] = useState(Array.from(new Map((notesList || []).map(n => [n.uiid, n])).values()));
  const [loading, setLoading] = useState(false);
  const fetchNotes = async () => {
    if (!applicantId) {
      // setNotes([]);
      return;
    };
    try {
      setLoading(true);
      const res = await getNotes({
        coll: "Note",
        filters: { candidateId: { type: "NONE", value: applicantId } },
        lim: 10,
        pg: 1,
        extret: "uiid firstName",
        ret: "uiid note addedBy addedOn",
        sort: { addedOn: -1 },
      });

      if (res?.data?.data) {
        const merged = [...notesList, ...res.data.data];
        const unique = Array.from(new Map(merged.map(item => [item.uiid, item])).values());
        dispatch(updateApplicantNotesList({ applicantId, notesList: unique }))
        dispatch(updateApplicantsNotesArray({ applicantId, notes: unique }))
        dispatch(updateApplicantNotesListBDM({ applicantId, notesList: unique }))
        // setNotes(unique);
      } else {
        // setNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
      showToast("Failed to load notes", "error");
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const optionsDate = { year: "numeric", month: "long", day: "2-digit" };
    const formattedDate = date.toLocaleDateString("en-US", optionsDate);

    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

    return `${formattedDate} ${formattedTime}`;
  };

  useEffect(() => {
    fetchNotes();
  }, [applicantId, refreshKey]);

  useEffect(() => {
    if (!notesList?.length) return;
    setNotes(prevNotes => {
      const merged = [...prevNotes, ...notesList];
      const unique = Array.from(
        new Map(merged.map(item => [item.uiid, item])).values()
      );
      return unique;
    });
  }, [notesList]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LogoLoader />
      </div>
    );
  }
  // if (!notes.length) {
  //   return (
  //     <div className="p-6 text-gray-500 text-sm">No notes available.</div>
  //   );
  // }
  return (
    <div className="p-4">
      <div className="flex justify-end mb-4">
        <Button
          icon={"add"}
          title={"Add Note"}
          size="sm"
          onClick={openNotesModal}
        />
      </div>
      {!notes.length ? (
        <div className="p-6 text-gray-500 text-sm text-center">
          No notes available.
        </div>
      ) : (
        notes.map((note) => (
          <DetailCard
            key={note?.uiid}
            size="xs"
            title={
              <div className="flex items-center gap-x-5 gap-y-2">
                <Avatar showInitials
                  // alt={"Ershad Mohammad"} 
                  alt={formatWords2(note?.addedBy?.firstName || "User")}
                  noBorder />
                {/* <div className="font-bold text-xs">
                {dayjs(note.addedOn).format("ddd, DD/MMM/YYYY hh:mm A")}
              </div> */}
                <div className="flex flex-col gap-y-1">
                  <div className="font-bold text-xs">
                    {formatWords2(note?.addedBy?.firstName || "User")}
                  </div>

                  <div className="font-bold text-xs text-gray-500">
                    {/* {dayjs(note?.addedOn).format("ddd, DD/MMM/YYYY hh:mm A")} */}
                    {formatDateTime(convertFromUTC(note?.addedOn))}
                  </div>
                </div>
              </div>
            }
            headeRight={
              <div className="p-2">
                <Button
                  icon={"more_vert"}
                  variant="text"
                  type="icon"
                  size="sm"
                  color="black"
                />
              </div>
            }
          >
            <div className="my-2 mx-1 text-sm p-2">
              {/* (Inspector or Inspection or Inspecting) and (Construction or Civil)
            and (Transportation or Bridge or “Complex Category 2” or “CC2”) */}
              {note.note || "-"}
            </div>
          </DetailCard>
        )))}

    </div>
  );
};

export default Notes;
